<template>
  <div
    class="form-item"
    :class="[
      form[field.fieldCode].require ? 'require' : '',
      field.fieldType,
      form[field.fieldCode]._description ? 'description' : '',
    ]"
  >
    <div class="form-item-label" v-if="field.fieldName">
      {{ field.fieldName }}
      <span v-if="field.unit">({{ field.unit }})</span>
      <span class="qoit">:</span>
    </div>
    <div
      class="form-item-value"
      :class="form[field.fieldCode].error ? 'error' : ''"
    >
      <input
        :type="field.inputType || 'text'"
        :disabled="disabled"
        v-if="
          field.fieldType === 'Input' && !form[field.fieldCode]._description
        "
        :placeholder="field.fieldPlaceholder || ''"
        v-model="form[field.fieldCode].value"
        @blur="validate(form[field.fieldCode])"
      />
      <input
        v-if="
          field.fieldType === 'Numeric' && !form[field.fieldCode]._description
        "
        type="text"
        :disabled="disabled"
        :placeholder="field.fieldPlaceholder || ''"
        v-model="form[field.fieldCode].value"
        @input="changeNumValue"
        @blur="validate(form[field.fieldCode])"
      />      
      <textarea
        v-if="field.fieldType === 'Text' && !form[field.fieldCode]._description"
        :placeholder="field.fieldPlaceholder || ''"
        :disabled="disabled"
        v-model="form[field.fieldCode].value"
        @blur="validate(form[field.fieldCode])"
        @input="showCurrentLenth"
        :style="field.componentStyle"
      ></textarea>
      <div style="text-align:right;color:gray" v-if="field.fieldType === 'Text' && !form[field.fieldCode]._description && this.field.fieldLength">
          <span id="span_Font_Length" style="font-size: 14px;">{{ form[this.field.fieldCode].length ?  this.form[this.field.fieldCode].length : 0 }}</span>
          <span style="font-size: 14px;">/</span>
          <span style="font-size: 14px;">{{this.field.fieldLength}}</span>
      </div> 
      <div
        class="form-item-value-text"
        v-if="
          form[field.fieldCode]._description &&
          (field.fieldType === 'Input' ||
            field.fieldType === 'Numeric' ||
            field.fieldType === 'Text')
        "
      >
        {{ form[field.fieldCode].value }}
      </div>
      <Datetime
        class="datetime-picker"
        v-if="field.fieldType === 'Date'"
        format="YYYY-MM-DD"
        :placeholder="field.fieldPlaceholder || ''"
        :readonly="disabled"
        v-model="form[field.fieldCode].value"
        @input="validate(form[field.fieldCode])"
      />
      <template
        v-if="
          field.fieldType === 'Radio' && !form[field.fieldCode]._description
        "
      >
      <!-- "entireRow":true, -->
        <div v-for="(option, idx) in field.valueList" :key="idx" >
          <input
            type="radio"
            :id="`${field.fieldCode}_${option.key}`"
            :name="field.fieldCode"
            :value="option.key"
            :disabled="disabled"
            @change="validate(form[field.fieldCode])"
            v-model="form[field.fieldCode].value"
          />
          <label :for="`${field.fieldCode}_${option.key}`">{{ option.value }}</label>
        </div>
      </template>
      <template
        v-if="
          field.fieldType === 'Select' && !form[field.fieldCode]._description
        "
      >
        <select
          :disabled="disabled"
          @change="selectChange"
          :value="form[field.fieldCode].value"
          :class="{ placeholder: !form[field.fieldCode].value }"
        >
          <option value="" disabled>
            {{ field.fieldPlaceholder || "" }}
          </option>
          <option
            v-for="(option, idx) in field.valueList"
            :key="idx"
            :value="option.key"
          >
            {{ option.value }}
          </option>
        </select>
      </template>
      <template
        v-if="
          field.fieldType === 'MultiSelect' && !form[field.fieldCode]._description
        "
      >
        <div class="multi-select" v-click-outside="closeMultiSelect">
          <div
            class="multi-select-display"
            :class="{ open: multiSelectOpen, placeholder: !selectedMultiLabels.length }"
            @click="toggleMultiSelect"
          >
            <span v-if="selectedMultiLabels.length">{{ selectedMultiLabels.join('、') }}</span>
            <span v-else>{{ field.fieldPlaceholder || '请选择' }}</span>
            <i class="multi-select-arrow"></i>
          </div>
          <div class="multi-select-panel" v-show="multiSelectOpen">
            <label
              class="multi-select-option"
              v-for="(option, idx) in field.valueList"
              :key="idx"
            >
              <input
                type="checkbox"
                :value="option.key"
                :checked="isMultiSelected(option.key)"
                :disabled="disabled"
                @change="toggleMultiOption(option.key)"
              />
              <span>{{ option.value }}</span>
            </label>
          </div>
        </div>
      </template>
      <template
        v-if="
          field.fieldType === 'Region' 
        "
      >
        <area-cascader         
          type='text'
          :level="1"
          v-model="form[field.fieldCode].value"  
          :placeholder="field.fieldPlaceholder"        
          :data="pcaa"></area-cascader>
      </template>
      <div
        v-if="
          form[field.fieldCode]._description &&
          (field.fieldType === 'Radio' || field.fieldType === 'Select' || field.fieldType === 'MultiSelect')
        "
        class="form-item-value-text"
      >
        {{ field.fieldType === 'MultiSelect' ? getMultiComputedValue(form[field.fieldCode].value, field.valueList) : getComputedValue(form[field.fieldCode].value, field.valueList) }}
      </div>
      <div
        style="font-size:13px;color:rgb(155, 155, 155);margin-top:5px"
        v-if="
          !form[field.fieldCode]._description && field.helptips && field.fieldType === 'Radio'        
        "
      >
        {{field.helptips}}
      </div>
      <div class="upload-wrap" v-if="field.fieldType === 'File'">
        <div
          class="upload-add"
          :class="loading ? 'loading' : ''"
          v-if="!disabled"
        >
          上传附件
          <input v-if="!loading" type="file" @change="onFileChange" />                 
        </div>
        <div style="vertical-align:bottom;margin-left:5px; color: #9b9b9b;font-size: 15px;display:inline-block" v-if=" !form[field.fieldCode]._description && field.helptips">{{field.helptips}}</div>   
        <div class="upload-file-wrap">
          <div
            class="upload-file"
            v-for="(item, index) in form[field.fieldCode].value"
            :key="index"
          >
            <a :href="item.url" target="_blank"> {{ item.name }}</a>
            <i
              class="upload-file-delete"
              v-if="!disabled"
              @click="deleteFile(index)"
            ></i>
          </div>
        </div>
      </div>
      <div class="error-tip" v-if="form[field.fieldCode].error">
        {{ form[field.fieldCode].error }}
      </div>
    </div>
  </div>
</template>

<script>
import upload from "@/service/upload";
import Datetime from "@/components/DatetimePicker";
import { pcaa } from '@/components/region-data';

export default {
  data() {
    return {
      loading: false,
      currentTextLength: 0,
      pcaa,
      multiSelectOpen: false,
    };
  },
  props: {
    field: Object,
    form: Object,
    disabled: {
      default: false,
    },
  },
  components: {
    Datetime,
  },
  mounted() {
    // console.log(this.form)
    // console.log(this.field)
    // debugger;
 
  },
  computed: {
    selectedMultiLabels() {
      if (this.field.fieldType !== 'MultiSelect') {
        return [];
      }
      // 按勾选顺序展示，不按下拉列表顺序
      const values = this.form[this.field.fieldCode].value || [];
      const optionMap = (this.field.valueList || []).reduce((map, item) => {
        map[item.key] = item.value;
        return map;
      }, {});
      return values
        .map((key) => optionMap[key])
        .filter(Boolean);
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  methods: {
    validate(field) {
      if (field.validate) {
        field.validate(field.value);
      }
    },
    changeNumValue(e) {
      const value = e.target.value;
      const fieldDecimalPoint = this.field.fieldDecimalPoint;
      if (value) {
        let tmpVal = value.replace(/[^\d\.]/g, "");
        const reg = new RegExp(
          `^(0|([1-9]\\d*))(\\.\\d{${new Array(fieldDecimalPoint)
            .fill(0)
            .map((item, idx) => idx + 1)
            .join(",")}})?$`
        ); // /^(0|([1-9]\d*))(\.\d{1,2})?$/; //正则验证保留 最多允许后输入两位小数
        if (!reg.test(tmpVal)) {
          tmpVal = tmpVal + "";
          tmpVal = tmpVal.substring(0, tmpVal.indexOf(".") + (fieldDecimalPoint+1));
          const n = tmpVal.split(".").length - 1;
          if (n > 1) {
            tmpVal = tmpVal.substring(0, tmpVal.indexOf("."));
          }
        }
        this.form[this.field.fieldCode].value = tmpVal;
      } else {
        this.form[this.field.fieldCode].value = "";
      }
    },
    selectChange(e) {
      const value = e.target.value;
      this.form[this.field.fieldCode].value = value;
      this.validate(this.form[this.field.fieldCode]);
    },
    toggleMultiSelect() {
      if (this.disabled) {
        return;
      }
      this.multiSelectOpen = !this.multiSelectOpen;
    },
    closeMultiSelect() {
      this.multiSelectOpen = false;
    },
    isMultiSelected(key) {
      const values = this.form[this.field.fieldCode].value || [];
      return values.indexOf(key) !== -1;
    },
    toggleMultiOption(key) {
      const field = this.form[this.field.fieldCode];
      const values = Array.isArray(field.value) ? [...field.value] : [];
      const index = values.indexOf(key);
      if (index === -1) {
        values.push(key);
      } else {
        values.splice(index, 1);
      }
      field.value = values;
      this.validate(field);
    },
    getMultiComputedValue(values, options) {
      if (!Array.isArray(values) || !values.length) {
        return '';
      }
      // 按勾选顺序展示文案
      const optionMap = (options || []).reduce((map, item) => {
        map[item.key] = item.value;
        return map;
      }, {});
      return values
        .map((key) => optionMap[key])
        .filter(Boolean)
        .join('、');
    },
    showCurrentLenth(e) {
      console.log(this.form);
      debugger;
      this.form[this.field.fieldCode].length = e.target.value ? e.target.value.length : 0
      
    },
    
    onFileChange($event) {
      console.log(this.form);
      const file = $event.target.files[0];
      console.log(this.field);
      if(file.size>this.field.maxSize){
        this.$message({
          type: 'error',
          content: '上传的文件已超过大小限制，请检查！'
        });
        return false
      }
      // if (this.form[this.field.fieldCode].value.length >= this.field.limit) {
      //   this.$message({
      //     type: 'error',
      //     content: `${this.field.fieldName}文件数量限制为${this.field.limit}，请检查！`
      //   });
      //   return false
      // }
      if (this.loading) return false;
      this.loading = true;
      upload(file)
        .then((url) => {
          console.log(this.field.fieldCode);          
          this.form[this.field.fieldCode].value.push({
            name: file.name,
            url,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteFile(idx) {
      this.form[this.field.fieldCode].value.splice(idx, 1);
    },
    getComputedValue(value, options) {
      const target = options.find((o) => o.key == value);
      if (target) {
        return target.value;
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
.form-item {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  &.require {
    .form-item-label {
      &::before {
        position: absolute;
        content: "*";
        color: #ff3b2f;
        left: -10px;
        top: 0;
      }
    }
  }

  &.description {
    margin-bottom: 0;
    border: 0.5px solid #e3e3e3;

    .form-item-label {
      min-height: 60px;
      line-height: 60px;
      background: #f1f1f1;
      padding-left: 10px;

      .qoit,
      &::before {
        display: none;
      }
    }

    .form-item-value {
      .form-item-value-text {
        padding-left: 10px;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  &-label {
    width: 150px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #787878;
    position: relative;
  }

  &.Input,
  &.Numeric {
    align-items: center;

    &.description {
      .form-item-value {
        border: none;
      }
    }

    .form-item-value {
      height: 28px;
      border-bottom: 1px solid #9e9e9e;

      input {
        outline: none;
        border: none;
        display: block;
        width: 100%;
        height: 100%;
        padding: 0 12px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #131415;

        &::placeholder {
          color: #9b9b9b;
          font-weight: 400;
        }
      }
    }
  }

  &.Radio {
    .form-item-value {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      > div {
        margin-right: 24px;
        margin-bottom: 0;
        display: flex;
        align-items: center;

        > input {
          margin-right: 8px;
          cursor: pointer;
        }

        > label {
          cursor: pointer;
        }
      }
    }
  }

  &.Date {
    align-items: center;

    &.description {
      .form-item-value {
        padding-left: 10px;
        border: none;
      }
    }

    .form-item-value {
      height: 28px;
      border-bottom: 1px solid #9e9e9e;
    }
  }

  &.Select {
    align-items: center;

    &.description {
      select {
        border: none;
      }
    }

    select {
      width: 100%;
      height: 33px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e6e7eb;
      outline: none;
      padding-left: 10px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1b2841;

      &.placeholder {
        color: #9b9b9b;
      }

      option {
        width: 41px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1b2841;
        line-height: 22px;
      }
    }
  }

  &.MultiSelect {
    align-items: center;

    .multi-select {
      position: relative;
      width: 100%;
    }

    .multi-select-display {
      width: 100%;
      height: 33px;
      min-height: 33px;
      padding: 0 28px 0 10px;
      border: 1px solid #e6e7eb;
      border-radius: 2px;
      background: #ffffff;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 31px;
      color: #1b2841;
      cursor: pointer;
      position: relative;
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.placeholder {
        color: #9b9b9b;
      }

      &.open {
        border-color: #e6e7eb;
        box-shadow: none;
      }
    }

    .multi-select-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      width: 0;
      height: 0;
      margin-top: -2px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 5px solid #1b2841;
      pointer-events: none;
    }

    .multi-select-panel {
      position: absolute;
      left: 0;
      right: 0;
      top: calc(100% + 2px);
      z-index: 20;
      max-height: 260px;
      overflow-y: auto;
      padding: 4px 0;
      background: #fff;
      border: 1px solid #e6e7eb;
      border-radius: 2px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .multi-select-option {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 10px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #1b2841;
      cursor: pointer;

      &:hover {
        background: #f5f5f5;
      }

      input {
        margin: 0;
      }
    }
  }

  &.Text {
    &.description {
      textarea {
        border: none;
      }
    }

    textarea {
      width: 100%;
      height: 120px;
      display: block;
      resize: none;
      box-sizing: border-box;
      outline: none;
      border: none;
      padding: 0;
      border: 1px solid #ddd;
      background: inherit;

      &::placeholder {
        color: #9b9b9b;
        font-weight: 400;
      }
    }
  }

  &.File {
    &.description {
      .upload-wrap {
        padding-top: 0;

        .upload-file-wrap {
          padding-top: 0;
        }
      }
    }

    .upload-wrap {
      // padding-top: 30px;

      .upload-file-wrap {
        display: flex;
        flex-wrap: wrap;
        // padding-top: 20px;
        padding-top: 0px;

        .upload-file {
          padding: 10px;
          background: #ffffff;
          height: 40px;
          color: #06ae63;
          border-radius: 5px;
          margin-right: 20px;
          margin-top: 10px;
          position: relative;

          &:hover {
            .upload-file-delete {
              display: block;
            }
          }

          &-delete {
            display: none;
            cursor: pointer;
            width: 15px;
            height: 15px;
            position: absolute;
            right: -4px;
            top: -4px;
            background: #ff3b2f url(../assets/images/icon-close.png) no-repeat
              center center;
            background-size: 6px 6px;
            border-radius: 50%;
          }
        }
      }

      .upload-add {
        padding: 10px;
        color: #ffffff;
        border-radius: 5px;
        width: 100px;
        padding-left: 30px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        background: #06ae63 url(../assets/images/icon-upload.png) no-repeat 5px
          center;
        background-size: 20px 20px;
        position: relative;
        display:inline-block;

        &.loading {
          background-image: url(../assets/images/icon-loading.gif);
          background-position: center center;
        }

        > input {
          position: absolute;
          cursor: pointer;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
    }
  }

  &-value {
    flex: 1;
    position: relative;

    .error-tip {
      position: absolute;
      left: 0;
      top: 100%;
      font-size: 12px;
      color: #ff3b2f;
      line-height: 20px;
      display: none;
    }

    &.error {
      border-bottom-color: #ff3b2f;

      .error-tip {
        display: block;
      }
    }
    .area-cascader-wrap{
      .area-select.large{
        width: 394px !important;
      }
    }
  }
}

</style>